import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useApplicationCommon } from "../utils/ApplicationCommon";


const CommonMenu = () => {
  const navigate = useNavigate();
  const { doAction } = useApplicationCommon("DEV", "COMMON", "MENU");
  const [isNavOpen, setIsNavOpen] = useState(false); // 네비게이션 메뉴 열림 상태
  const [isCallOver, setIsCallOver] = useState(false); // call-3 토글 상태
  const [isScrolled, setIsScrolled] = useState(false); // 스크롤 여부 확인
  const [isMenuOpen, setIsMenuOpen] = useState(false); // 모바일메뉴
  const [isOpen1, setIsOpen1] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const [isOpen4, setIsOpen4] = useState(false);
  const [isOpen5, setIsOpen5] = useState(false);
  const [isOpen6, setIsOpen6] = useState(false);
  const [text, setText] = useState();

    // ✅ 호스트네임에 따라 로고 변경
    const hostname = window.location.hostname;
    const root = document.documentElement;
    if (hostname.includes("gnbsoftec.co.kr")) {

      if(!isNavOpen)root.style.setProperty("--logo-url", 'url("/asset/img/common/logo_w_gnb.svg")');
      else root.style.setProperty("--logo-url", 'url("/asset/img/common/logo_c.svg")');
      
      root.style.setProperty("--mologo-url", 'url("/asset/img/common/logo_c.svg")');

    } else if (hostname.includes("puresolution.co.kr")) {

        if(!isNavOpen)root.style.setProperty("--logo-url", 'url("/asset/img/common/logo_w_pure.png")');
        else root.style.setProperty("--logo-url", 'url("/asset/pure/img/common/logo_c.png")');
        
        root.style.setProperty("--mologo-url", 'url("/asset/pure/img/common/logo_c.png")');
        
    } else {

      if(!isNavOpen)root.style.setProperty("--logo-url", 'url("/asset/img/common/logo_w_pure.png")');
      else root.style.setProperty("--logo-url", 'url("/asset/pure/img/common/logo_c.png")');

      root.style.setProperty("--mologo-url", 'url("/asset/pure/img/common/logo_c.png")');
      
    }

   const onChange = (e) => {
    if (hostname.includes("gnbsoftec.co.kr")) {
      setText("지엔비소프텍");
    }else if (hostname.includes("puresolution.co.kr")) {
      setText("퓨어솔루션");
    }else {
      setText("퓨어솔루션");
    }

      
   }
   
   

  const openMenu = () => {
    setIsMenuOpen(true);
     document.body.style.overflow = "hidden"; // 스크롤 막기
    
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    document.body.style.overflow = ""; // 스크롤 복구
  };

  

  // 스크롤 시 배경색 변경
  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY > 100;
      setIsScrolled(scrolled);

      // ✅ 기존 클래스를 모두 제거 후, 필요한 클래스만 추가
      root.classList.remove("gnbsoftec", "puresolution", "default-site");

      if (scrolled) {
        if (hostname.includes("gnbsoftec.co.kr")) {
          root.classList.add("gnbsoftec");
        } else if (hostname.includes("puresolution.co.kr")) {
          root.classList.add("puresolution");
        } else {
          root.classList.add("default-site");
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  return (
    <header className={`header bgcolor01 ${isNavOpen ? "open" : ""}  ${isScrolled ? "scrolled" : ""}`} id={isScrolled  ? "bgcolor01" : ""}>
      <div id="inner">
        <h1>
          <Link to="/">
            <div
              
              style={{
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "contain",
                width: "170px",
                height: "70px",
                
              }}
            />
          </Link>
        </h1>

        {/* 네비게이션 메뉴 */}
        <nav className={`main-nav ${isNavOpen ? "open" : ""}`}
         onMouseEnter={() => setIsNavOpen(true)} // Hover 시 메뉴 열림
         onMouseLeave={() => setIsNavOpen(false)} // Hover 해제 시 메뉴 닫힘
        >

          <ul className="col06">
            <li><Link to="/GNBPURE00000S">기업소개</Link>
            <div style={{ display: isNavOpen ? "block" : "none" }}>
                <ul className="pcdepth2">
                    <li><Link to="/GNBPURE00000S">CEO인사말</Link></li>
                    <li><Link to="/GNBPURE00001S">ABOUT US</Link></li>
                    <li><Link to="/GNBPURE03001S">우리회사소식</Link></li>
                    <li><Link to="/GNBPURE00002S">사업실적</Link></li>			
                    <li><Link to="/GNBPURE00003S">오시는길</Link></li>
                  </ul>
              </div>
            </li>
            <li><Link to="/GNBPURE01001S">사업분야</Link>
            <div style={{ display: isNavOpen ? "block" : "none" }}>
                  <ul className="pcdepth2">
                    <li><Link to="/GNBPURE01001S">시스템통합(SI)</Link></li>
                    <li><Link to="/GNBPURE01002S">시스템유지보수(SM)</Link></li>
                    <li><Link to="/GNBPURE01003S">솔루션제공</Link></li>
                    <li><Link to="/GNBPURE01004S">애플리케이션서비스제공(ASP)</Link></li>
                    <li><Link to="/GNBPURE01005S">IT컨설팅서비스</Link></li>
                  </ul>
              </div>
            </li>
            <li><Link to="/GNBPURE02000S">제품소개</Link>
            <div style={{ display: isNavOpen ? "block" : "none" }}>
                  <ul className="pcdepth2">
                    <li><Link to="/GNBPURE02001S">온라인대출</Link></li>
                    <li><Link to="/GNBPURE02002S">스탁론</Link></li>
                    <li><Link to="/GNBPURE02003S">NPL</Link></li>
                    <li><Link to="/GNBPURE02004S">기관연계시스템</Link></li>
                    <li><Link to="/GNBPURE02000S">통합솔루션</Link></li>
                  </ul>
              </div>
            </li>
            <li><Link to="/GNBPURE04001S">고객지원</Link>
            <div style={{ display: isNavOpen ? "block" : "none" }}>
                    <ul className="pcdepth2">
                      <li><Link to="/GNBPURE04001S">제휴문의</Link></li>
                      <li><Link to="/GNBPURE04002S">NOTICE</Link></li>
                      <li><Link to="/GNBPURE04003S">Contact Us</Link></li>
                    </ul>
              </div>  
            </li>
            <li><Link to="/GNBPURE06001S">인재 채용</Link>
            <div style={{ display: isNavOpen ? "block" : "none" }}>
                  <ul className="pcdepth2">
                    <li><Link to="/GNBPURE06001S">인재상</Link></li>
                    <li><Link to="/GNBPURE06002S">복리후생</Link></li>
                    <li><Link to="/GNBPURE06003S">채용공고</Link></li>
                  </ul>
            </div>  
            </li>
          </ul>

        </nav>

            <ul className="sub-nav col02">
              <li><Link to="/GNBPURE04003S">Contact Us</Link></li>
              <li><a href="../../asset/img/common/CompanyOverview.pdf">회사소개서</a></li>
            </ul>


          {/* 모바일 메뉴 */}
          <button type="button" className="btn-menu" onClick={openMenu}>전체메뉴</button>
          <div className={`mo-bg ${isMenuOpen ? "on" : ""}`} onClick={closeMenu}></div>
          <div className={`mo-main-nav ${isMenuOpen ? "on" : ""}`}>
            <div className="topmenu">
              <h1><Link to="/" onChange={onChange} onClick={closeMenu}></Link></h1>
              <Link to="" className="m-close" onClick={closeMenu}>모바일 메뉴 닫기</Link>
            </div>
            <ul className="botmenu">
              <li><a href="#none" className={isOpen1 ? "on" : ""} onClick={(e) => {e.preventDefault(); setIsOpen1(!isOpen1);}}>기업소개</a>
                  <ul className="mdepth2" style={{ display: isOpen1 ? "block" : "none" }}>
                    <li><Link to="/GNBPURE00000S" onClick={closeMenu}>CEO인사말</Link></li>
                    <li><Link to="/GNBPURE00001S" onClick={closeMenu}>ABOUT US</Link></li>
                    <li><Link to="/GNBPURE03001S" onClick={closeMenu}>우리회사소식</Link></li>
                    <li><Link to="/GNBPURE00002S" onClick={closeMenu}>사업실적</Link></li>			
                    <li><Link to="/GNBPURE00003S" onClick={closeMenu}>오시는길</Link></li>
                  </ul>
              </li>
              <li><a href="#none" className={isOpen2 ? "on" : ""} onClick={(e) => {e.preventDefault(); setIsOpen2(!isOpen2);}}>사업분야</a>
                  <ul className="mdepth2" style={{ display: isOpen2 ? "block" : "none" }}>
                    <li><Link to="/GNBPURE01001S" onClick={closeMenu}>시스템통합(SI)</Link></li>
                    <li><Link to="/GNBPURE01002S" onClick={closeMenu}>시스템유지보수(SM)</Link></li>
                    <li><Link to="/GNBPURE01003S" onClick={closeMenu}>솔루션제공</Link></li>
                    <li><Link to="/GNBPURE01004S" onClick={closeMenu}>애플리케이션서비스제공(ASP)</Link></li>
                    <li><Link to="/GNBPURE01005S" onClick={closeMenu}>IT컨설팅서비스</Link></li>
                  </ul>
              </li>
              <li><a href="#none" className={isOpen3 ? "on" : ""} onClick={(e) => {e.preventDefault(); setIsOpen3(!isOpen3);}}>제품소개</a>
                  <ul className="mdepth2" style={{ display: isOpen3 ? "block" : "none" }}>
                    <li><Link to="/GNBPURE02001S" onClick={closeMenu}>온라인대출</Link></li>
                    <li><Link to="/GNBPURE02002S" onClick={closeMenu}>스탁론</Link></li>
                    <li><Link to="/GNBPURE02003S" onClick={closeMenu}>NPL</Link></li>
                    <li><Link to="/GNBPURE02004S" onClick={closeMenu}>기관연계시스템</Link></li>
                    <li><Link to="/GNBPURE02000S" onClick={closeMenu}>통합솔루션</Link></li>
                  </ul>

            </li>
            <li><a href="#none" className={isOpen5 ? "on" : ""} onClick={(e) => {e.preventDefault(); setIsOpen5(!isOpen5);}}>고객지원</a>
                    <ul className="mdepth2" style={{ display: isOpen5 ? "block" : "none" }}>
                      <li><Link to="/GNBPURE04001S" onClick={closeMenu}>제휴문의</Link></li>
                      <li><Link to="/GNBPURE04002S" onClick={closeMenu}>NOTICE</Link></li>
                      <li><Link to="/GNBPURE04003S" onClick={closeMenu}>Contact Us</Link></li>
                    </ul>
            </li>
            <li><a href="#none" className={isOpen6 ? "on" : ""} onClick={(e) => {e.preventDefault(); setIsOpen6(!isOpen6);}}>인재채용</a>
                  <ul className="mdepth2" style={{ display: isOpen6 ? "block" : "none" }}>
                    <li><Link to="/GNBPURE06001S" onClick={closeMenu}>인재상</Link></li>
                    <li><Link to="/GNBPURE06002S" onClick={closeMenu}>복리후생</Link></li>
                    <li><Link to="/GNBPURE06003S" onClick={closeMenu}>채용공고</Link></li>
                  </ul>
              </li>
            </ul>


          </div>
      </div>
      
       {/* 서브메뉴 배경 */}
       <div className={`subback ${isNavOpen ? "open" : ""}`}></div>

    </header>
  );
};
//export test 작업중
export default CommonMenu;